import React, { ReactNode } from 'react';
import isEmpty from 'lodash/isEmpty';
import { Box, Stack, Text } from '@solvhealth/jigsaw-v1';
import { useTranslation } from 'react-i18next';
import { InsuranceProfile } from '~/components/Paperwork/hooks/useInsuranceProfiles';
import InsuranceProfileCards from '~/components/Paperwork/components/Payment/InsuranceProfileCards';

type Props = {
  insuranceProfiles: InsuranceProfile[];
  handleInsuranceProfileSelect: (insuranceProfileId?: string) => void;
  selectedInsurance?: InsuranceProfile;
  manualInsuranceInputs: ReactNode;
};

const ExistingInsuranceProfiles = (props: Props) => {
  const {
    insuranceProfiles,
    handleInsuranceProfileSelect,
    selectedInsurance,
    manualInsuranceInputs,
  } = props;
  const { t } = useTranslation(['paperwork', 'common']);

  if (isEmpty(insuranceProfiles)) {
    return (
      <Stack space={4}>
        <Box>
          <Text pb={1} textColor="gray-600" variant="subtitle">
            {t('paperwork:payment.noInsuranceFound.title')}
          </Text>
          <Text muted variant="body">
            {t('paperwork:payment.noInsuranceFound.body')}
          </Text>
        </Box>
        <Box backgroundColor="gray-100" borderRadius="base" px={4} py={7} textAlign="center">
          <Text pb={1} textColor="gray-500" variant="subtitle">
            {t('paperwork:payment.noInsuranceFound.promptTitle')}
          </Text>
          <Text textColor="gray-500" variant="body">
            {t('paperwork:payment.noInsuranceFound.promptBody')}
          </Text>
        </Box>
      </Stack>
    );
  }
  return (
    <>
      <Stack alignItems="center">
        <Box width="100%">
          <InsuranceProfileCards
            handleInsuranceProfileSelect={handleInsuranceProfileSelect}
            insuranceProfiles={insuranceProfiles}
            manualInsuranceInputs={manualInsuranceInputs}
            selectedProfileId={selectedInsurance?.insurance_profile_id}
          />
        </Box>
      </Stack>
    </>
  );
};

export default ExistingInsuranceProfiles;
